// Static test data for D-Lab diagnostic laboratory

export const labTests = [
  {
    id: 1,
    name: "Complete Blood Count (CBC)",
    price: "₹500",
    shortDescription: "Comprehensive blood cell analysis",
    description: "A Complete Blood Count (CBC) measures different components of your blood including red blood cells, white blood cells, hemoglobin, hematocrit, and platelets. This test helps diagnose anemia, infections, and many other disorders.",
    sample: "Blood",
    reportTime: "24 hours",
    category: "Blood Tests",
    icon: "Droplets",
    popular: true
  },
  {
    id: 2,
    name: "Lipid Profile",
    price: "₹800",
    shortDescription: "Cholesterol and triglycerides check",
    description: "Lipid Profile test measures cholesterol and triglyceride levels in your blood. It includes Total Cholesterol, HDL, LDL, and VLDL measurements. Essential for assessing cardiovascular health and heart disease risk.",
    sample: "Blood",
    reportTime: "24 hours",
    category: "Blood Tests",
    icon: "Heart",
    popular: true
  },
  {
    id: 3,
    name: "Thyroid Function Test (TFT)",
    price: "₹600",
    shortDescription: "T3, T4, and TSH levels",
    description: "Thyroid Function Test measures T3, T4, and TSH levels to assess thyroid gland function. Helps diagnose hypothyroidism, hyperthyroidism, and other thyroid disorders that affect metabolism and energy levels.",
    sample: "Blood",
    reportTime: "48 hours",
    category: "Hormone Tests",
    icon: "Activity",
    popular: true
  },
  {
    id: 4,
    name: "Blood Sugar (Fasting & PP)",
    price: "₹400",
    shortDescription: "Diabetes screening test",
    description: "Measures blood glucose levels in fasting state and post-meal (PP). Essential for diagnosing and monitoring diabetes, prediabetes, and blood sugar control. Includes HbA1c for long-term glucose assessment.",
    sample: "Blood",
    reportTime: "24 hours",
    category: "Blood Tests",
    icon: "Gauge",
    popular: false
  },
  {
    id: 5,
    name: "Liver Function Test (LFT)",
    price: "₹700",
    shortDescription: "Comprehensive liver health check",
    description: "LFT measures enzymes and proteins in blood to assess liver health. Includes SGOT, SGPT, bilirubin, albumin, and alkaline phosphatase. Helps diagnose liver diseases, hepatitis, and monitor liver function.",
    sample: "Blood",
    reportTime: "24 hours",
    category: "Blood Tests",
    icon: "HeartPulse",
    popular: false
  },
  {
    id: 6,
    name: "Kidney Function Test (KFT)",
    price: "₹650",
    shortDescription: "Renal health assessment",
    description: "KFT evaluates kidney function through blood urea nitrogen, creatinine, uric acid, and electrolyte levels. Essential for detecting kidney disease, monitoring kidney health, and assessing waste filtration.",
    sample: "Blood",
    reportTime: "24 hours",
    category: "Blood Tests",
    icon: "Waves",
    popular: false
  },
  {
    id: 7,
    name: "Vitamin D Test",
    price: "₹1,200",
    shortDescription: "Vitamin D3 level measurement",
    description: "Measures 25-hydroxyvitamin D levels to assess vitamin D status. Important for bone health, immune function, and overall wellness. Deficiency is common and can lead to various health issues.",
    sample: "Blood",
    reportTime: "48 hours",
    category: "Vitamin Tests",
    icon: "Sun",
    popular: false
  },
  {
    id: 8,
    name: "Vitamin B12 Test",
    price: "₹900",
    shortDescription: "B12 deficiency screening",
    description: "Measures vitamin B12 levels in blood. B12 is essential for red blood cell formation, neurological function, and DNA synthesis. Deficiency can cause anemia, fatigue, and neurological problems.",
    sample: "Blood",
    reportTime: "48 hours",
    category: "Vitamin Tests",
    icon: "Sparkles",
    popular: false
  },
  {
    id: 9,
    name: "HbA1c Test",
    price: "₹550",
    shortDescription: "Long-term diabetes monitoring",
    description: "HbA1c measures average blood sugar levels over the past 2-3 months. Gold standard for diabetes management and monitoring. Helps assess diabetes control and adjust treatment plans.",
    sample: "Blood",
    reportTime: "24 hours",
    category: "Blood Tests",
    icon: "TrendingUp",
    popular: true
  },
  {
    id: 10,
    name: "Urine Routine Examination",
    price: "₹300",
    shortDescription: "Complete urine analysis",
    description: "Comprehensive urine test checking for signs of kidney disease, urinary tract infections, diabetes, and other conditions. Includes physical, chemical, and microscopic examination of urine.",
    sample: "Urine",
    reportTime: "12 hours",
    category: "Urine Tests",
    icon: "Beaker",
    popular: false
  },
  {
    id: 11,
    name: "Dengue Antigen Test",
    price: "₹850",
    shortDescription: "Early dengue detection",
    description: "NS1 antigen test for early detection of dengue fever. Can detect dengue infection within the first few days of fever onset. Important for timely diagnosis and management of dengue.",
    sample: "Blood",
    reportTime: "6 hours",
    category: "Infectious Disease",
    icon: "Bug",
    popular: false
  },
  {
    id: 12,
    name: "COVID-19 RT-PCR Test",
    price: "₹600",
    shortDescription: "COVID-19 detection",
    description: "RT-PCR test is the gold standard for COVID-19 diagnosis. Detects viral genetic material. Required for travel, diagnosis of active infection, and screening purposes.",
    sample: "Nasal/Throat Swab",
    reportTime: "24 hours",
    category: "Infectious Disease",
    icon: "Shield",
    popular: true
  }
];

// Categories for filtering
export const testCategories = [
  { id: "all", name: "All Tests", count: labTests.length },
  { id: "blood", name: "Blood Tests", count: labTests.filter(t => t.category === "Blood Tests").length },
  { id: "hormone", name: "Hormone Tests", count: labTests.filter(t => t.category === "Hormone Tests").length },
  { id: "vitamin", name: "Vitamin Tests", count: labTests.filter(t => t.category === "Vitamin Tests").length },
  { id: "urine", name: "Urine Tests", count: labTests.filter(t => t.category === "Urine Tests").length },
  { id: "infectious", name: "Infectious Disease", count: labTests.filter(t => t.category === "Infectious Disease").length }
];

// Get test by ID
export const getTestById = (id) => {
  return labTests.find(test => test.id === parseInt(id));
};

// Get popular tests
export const getPopularTests = () => {
  return labTests.filter(test => test.popular);
};

// Get tests by category
export const getTestsByCategory = (category) => {
  if (category === "all") return labTests;
  return labTests.filter(test => test.category === category);
};
